/* topics will list all the topics
  *
  *
  * writers will be able to see their topics ( being reviewed, or that we approved ) and approved topics of all so that they can claim it.
  * basket : my submissions
  * basket : claim a topic
  *
  * editors will see all the topics of their sites, with a basket that let them find the ones to approve or disapprove.
  * basket : topics to approve
  * basket : All
  *
  * ** all action will need to be done trough the form to insure most recent data as been refreshed.
  *
  * filter available :
  *
  * submited by : autocomplete user by username or name
  * topic : keywords
  * submit date : created on start/end
  *
  * */
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { topicsList_template } from "../components/templates/topicsList_template";


declare var ko: any;
declare var page: any;

export class topics extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected listTemplate: topicsList_template;
    protected validationsList: validationsList_template;

    protected getModuleName(){
        return "topics";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.validationsList = new validationsList_template("validationList", this.viewModel, this);

        // create the topics list
        this.listTemplate = new topicsList_template("list", this.viewModel, this);

        return [this.validationsList.build(), this.listTemplate.build()];
    }

    public fillPage() : void{

        // init calendar
        // ** this need to be done AFTER the element is inserted in the page
        // as it uses query selector to load the calendars
        // this.getFormData();
        this.filterList();
    }

    // obtain the dynamic data required to fill the formulary
    protected getFormData(){

        this.loadingIn(this.listTemplate.builtTemplate);

        let id: number;
        let action: string;


        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/topics/list/";
        let usrReq_params: Array<Array<string>> = [];
        // usrReq_params.push(["data", ko.toJSON(this.viewModel["topics"])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }
    //
    // use the form data to fill the form
    protected onGetFormDataReturn(req, obj){

        return function(){
            if (req.request.readyState == 4) {

                let thisModule = (<topics>obj);
                let responseParsed = JSON.parse(req.request.response);
                if(  req.request.status == 200  ){

                    let vnApp = thisModule.getVnAppZone().app;
                    let topics = responseParsed.topics;

                    if(topics !== undefined){
                        obj.listTemplate.setTopics(topics);
                    }

                    obj.loadingOut(obj.listTemplate.builtTemplate);
                }
                else{
                    let msg = "error: while obtaining the form data - (" + req.request.status +")";
                    obj.validationsList.setSingleMessage({field: "error", "label": req.request.status, message: msg});
                    window.scrollTo(0, 0);

                }
            }
        }
    }

    protected viewTopic(id){
        this.saveViewModule(this.listTemplate.getViewModelForRequest());
        page('/brand/' + this.getVnAppZone().getGlobal("idBrand") + '/topics/edit/'+id);
    }

    protected addTopic(){
        this.saveViewModule(this.listTemplate.getViewModelForRequest());
        page('/brand/' + this.getVnAppZone().getGlobal("idBrand") + '/topics/add');
    }

    protected filterSimpleOnChange(){
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.listTemplate.builtTemplate.children.namedItem("list-results"));

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = { list         : { orderBy : this.viewModel.list.orderBy, orderByDirection : this.viewModel.list.orderByDirection }
            ,filter       : this.viewModel.list.filter
            ,pagination   : this.viewModel.list.pagination
        };

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/topics/list/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function(){

            if( localCheck == _myThis.XHRHdl.requestId ){
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onFilterRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onFilterRequestReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if(  req.request.status == 200  ){
                    obj.updateList(responseParsed);
                }
                else{
                    obj.onUpdateError(req.request.status, responseParsed);
                }


                // LOADING : ends
                obj.loadingOut(obj.listTemplate.builtTemplate.children.namedItem("list-results"));
            }
        }
    }

    protected paginationOnPageClick(){
        this.filterList();
    }

    protected updateList(responseParsed: any){

        // set users list
        let topics = [];
        for (let item of responseParsed.topics) {

            topics.push( {
                title: item.title
                ,status: item.status
                ,dateCreated: item.dateCreated
                ,dateSubmitted: item.dateSubmitted
                ,dateUpdated: item.dateUpdated
                ,id: item.id
            } )
        }

        this.listTemplate.setTopics(topics);

        // update the paginator
        this.viewModel.list.pagination.itemCount(responseParsed.topicsCount);

    }

}



// WEBPACK FOOTER //
// ./js/modules/topics.ts